import { getAllUsers, addNewUser, deleteUser, updateUser, confirmNewMail } from "src/actions/userActions";
export const REQUEST_USERS = "request_user";
export const RECEIVE_USERS = "receive_user";
export const RECEIVE_USERS_ERROR = "receive_user_error";
export const REQUEST_ADD_USER = "request_add_user";
export const RECEIVE_ADD__USER = "receive_add_user";
export const ADD_USER_ERROR = "add_user_error";
export const REQUEST_DELETE_USER = "request_delete_user";
export const RECEIVE_DELETE_USER = "receive_delete_user";
export const DELETE_USER_ERROR = "delete_user_error";
export const REQUEST_UPDATE_USER = "request_update_user";
export const RECEIVE_UPDATE_USER = "receive_update_user";
export const UPDATE_USER_ERROR = "update_user_error";
export const REQUEST_CONFIRM_MAIL = "request_confirm_mail";
export const RECEIVE_CONFIRM_MAIL = "receive_confirm_mail";
export const CONFIRM_MAIL_ERROR = "confirm_mail_error";

const getAllUsersRedux = () => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_USERS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_USERS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: RECEIVE_USERS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { data } = await getAllUsers();
			const { users } = data;
			return onSuccess(users);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const addUserRedux = newUser => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_ADD_USER,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_ADD__USER,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: ADD_USER_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			newUser.emailExpire = newUser.emailExpire ? newUser.emailExpire.toString() : "";
			//make api call
			const response = await addNewUser(newUser);
			const { user } = response;

			return onSuccess(user);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const deleteUserRedux = userId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_DELETE_USER,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_DELETE_USER,
				payload: success,
			});

			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: DELETE_USER_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await deleteUser(userId);
			const { deletedUser } = response;

			return onSuccess(deletedUser);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const updateUserRedux = values => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_UPDATE_USER,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_UPDATE_USER,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: UPDATE_USER_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await updateUser(values);
			const { updatedUser } = response;

			return onSuccess(updatedUser);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const confirmNewMailRedux = uri => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_CONFIRM_MAIL,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_CONFIRM_MAIL,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: CONFIRM_MAIL_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await confirmNewMail(uri);

			return onSuccess(response);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

export { getAllUsersRedux, addUserRedux, deleteUserRedux, updateUserRedux, confirmNewMailRedux };
